import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { useLang } from "../../i18n/LanguageContext";

// Graphique purement décoratif : la pièce « frétille » de quelques millicents
// autour de 1 €. Il n'a AUCUN effet sur les paiements : 1 pièce = 1 €, toujours.
const POINTS = 40;
const MAX_MILLICENTS = 9; // ± 0,00009 €

const nextValue = (prev) => {
  const step = Math.round((Math.random() - 0.5) * 6); // −3 à +3 millicents
  return Math.max(-MAX_MILLICENTS, Math.min(MAX_MILLICENTS, prev + step - Math.sign(prev) * (Math.random() < 0.3 ? 1 : 0)));
};

const seed = () => {
  const arr = [0];
  for (let i = 1; i < POINTS; i++) arr.push(nextValue(arr[i - 1]));
  return arr;
};

const CoinMoodChart = () => {
  const { t, lang } = useLang();
  const [data, setData] = useState(seed);

  useEffect(() => {
    const id = setInterval(() => setData((d) => [...d.slice(1), nextValue(d[d.length - 1])]), 3000);
    return () => clearInterval(id);
  }, []);

  const sep = lang === "en" ? "." : ",";
  const fmt = (mc) => `${(1 + mc / 100000).toFixed(5).replace(".", sep)} €`;
  const last = data[data.length - 1];
  const prev = data[data.length - 2];

  return (
    <div className="rounded-xl bg-creme px-3 pt-3 pb-2">
      <div className="flex items-baseline justify-between text-xs">
        <span className="font-semibold text-stone-600">✨ {t("Bourse")}</span>
        <span className={`font-mono font-bold ${last > prev ? "text-sauge" : last < prev ? "text-red-600" : "text-prune"}`}>
          {last > prev ? "▲" : last < prev ? "▼" : "•"} {fmt(last)}
        </span>
      </div>
      <div className="h-24 mt-1">
        <Line
          data={{
            labels: data.map((_, i) => i),
            datasets: [
              {
                data,
                fill: true,
                backgroundColor: "rgba(80,40,135,0.08)",
                borderColor: "#502887",
                borderWidth: 2,
                tension: 0.35,
                pointRadius: 0,
              },
            ],
          }}
          options={{
            maintainAspectRatio: false,
            animation: { duration: 400 },
            plugins: { legend: { display: false }, tooltip: { enabled: false } },
            scales: {
              x: { display: false },
              y: {
                min: -MAX_MILLICENTS - 1,
                max: MAX_MILLICENTS + 1,
                ticks: { maxTicksLimit: 3, callback: (v) => fmt(v), font: { size: 10 } },
                grid: { color: "rgba(0,0,0,0.05)" },
              },
            },
          }}
        />
      </div>
      <p className="text-[11px] text-stone-500 leading-snug">
        {t("NB : la valeur réelle ne change jamais, 1 pièce = 1 €.")}
      </p>
    </div>
  );
};

export default CoinMoodChart;
